import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getAppCfg } from '../core/app-cfg';
import { getDomainCfg } from '../core/state';
import { ProjectData } from '../core/types';
import { requestEditData } from './EditProjectData';
import { useState } from 'react';

export const ProjectNameLabel = (props: { project: ProjectData }) => {
  const [isHovered, setIsHovered] = useState(false);

  const label = getProjectText(props.project);
  const editable = props.project?.templateProject ? true : false; 
  const editableClass = editable ? "editable" : "";

  const requestEditProjectData = () => {
    if (!editable) return;
    console.log("edit requested");
    requestEditData();
  }

  const handleMouseEnter = () => setIsHovered(true);
  const handleMouseLeave = () => setIsHovered(false);

  return (
    <span 
      className={`navbar-brand ${editableClass}`} 
      onClick={requestEditProjectData} 
      onMouseEnter={handleMouseEnter} 
      onMouseLeave={handleMouseLeave}
    >
      {label}
      {editable && (
        <>
          &nbsp;
          {isHovered ? (
            <FontAwesomeIcon icon="pen" />
          ) : (
            <span style={{ visibility: 'hidden' }}>
              <FontAwesomeIcon icon="pen" />
            </span>
          )}
        </>
      )}
    </span>
  );
}
const getProjectText = (project : ProjectData) : string => {

  if (getDomainCfg().viewSettings.features.showProjectCode === true) {
    return `${project?.project} [${getAppCfg().projectId}]`;
  }
  return project?.project;
}
